var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_action_filter"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8293 7H21V9H10.8293C10.4175 10.1652 9.30622 11 8 11C6.69378 11 5.58254 10.1652 5.17071 9H3V7H5.17071C5.58254 5.83481 6.69378 5 8 5C9.30622 5 10.4175 5.83481 10.8293 7ZM9 8C9 8.55228 8.55228 9 8 9C7.44772 9 7 8.55228 7 8C7 7.44772 7.44772 7 8 7C8.55228 7 9 7.44772 9 8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8293 15H21V17H18.8293C18.4175 18.1652 17.3062 19 16 19C14.6938 19 13.5825 18.1652 13.1707 17H3V15H13.1707C13.5825 13.8348 14.6938 13 16 13C17.3062 13 18.4175 13.8348 18.8293 15ZM17 16C17 16.5523 16.5523 17 16 17C15.4477 17 15 16.5523 15 16C15 15.4477 15.4477 15 16 15C16.5523 15 17 15.4477 17 16Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionFilter);
export default __webpack_public_path__ + "static/media/ic_action_filter.ced6ecfde3cb6a45a341bc62d5a81808.svg";
export { ForwardRef as ReactComponent };